import { Dropdown } from "react-bootstrap";

const AssistantSuggestions = ({
  canUseActions,
  generalSuggestions,
  isSending,
  onSelect,
  resultActionGroups,
  resultActionsLabel,
}) => (
  <div className="ai-suggestions">
    {resultActionGroups.length ? (
      <Dropdown drop="up">
        <Dropdown.Toggle
          className="ai-result-actions-toggle"
          disabled={isSending || !canUseActions}
          size="sm"
          variant="outline-primary"
        >
          {resultActionsLabel}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {resultActionGroups.map((group, groupIndex) => (
            <div key={group.label}>
              {groupIndex > 0 ? <Dropdown.Divider /> : null}
              <Dropdown.Header>{group.label}</Dropdown.Header>
              {group.items.map((suggestion) => (
                <Dropdown.Item
                  as="button"
                  disabled={isSending || !canUseActions}
                  key={suggestion}
                  onClick={() => onSelect(suggestion)}
                >
                  {suggestion}
                </Dropdown.Item>
              ))}
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    ) : null}

    <div className="ai-suggestions-scroll">
      {generalSuggestions.map((suggestion) => (
        <button
          className="ai-suggestion-button"
          disabled={isSending || !canUseActions}
          key={suggestion}
          onClick={() => onSelect(suggestion)}
          type="button"
        >
          {suggestion}
        </button>
      ))}
    </div>
  </div>
);

export default AssistantSuggestions;
